import React from "react";
import { useTranslation } from 'react-i18next';

const useModels = () => {
    const { t } = useTranslation();
    
    return {
        icons: {
            format: "fa-pills",
            trash: "fa-trash-can",
            line: "fa-draw-polygon",
            "machine-model": "fa-hard-drive",
            home: "fa-home",
            start: "fa-play",
        },
        main: {
            icon: "fa-home",
            title: t("menu.main_panel"),
            url: "/",
        },
        admin: {
            icon: "fa-list-alt",
            title: t("menu.admin_panel"),
            url: "/admin",
        },
        format: {
            icon: "fa-pills",
            title: t("menu.formats"),
            url: "/formats",
        },
        storagePlace: {
            icon: "fa-inbox",
            title: t("menu.storage_places"),
            url: "/storage",
        },
        formatDeleted: {
            icon: "fa-trash-can",
            title: t("menu.formats_withdrawn"),
            url: "/formatsDeleted",
        },
        font: {
            icon: "fa-font",
            title: t("menu.font_management"),
            url: "/fonts",
            inventory: {
                icon: "fa-boxes-stacked",
                title: t("menu.inventory"),
            }
        },
        management: {
            icon: "fa-bars-progress",
            title: t("menu.format_management"),
            url: "/management",
        },
        production: {
            icon: "fa-diagram-project",
            title: t("menu.production"),
            url: "/production",
        },
        simulation: {
            icon: "fa-compass-drafting",
            title: t("menu.simulation"),
        },
        storage: {
            icon: "fa-box",
            title: t("menu.storage"),
            url: "storage",
            actionType: "STORAGE",
        },
        "part-replacement": {
            icon: "fa-sync-alt",
            title: t("menu.exchange"),
            url: "part-replacement",
            actionType: "REPLACEMENT",
        },
        "part-withdrawal": {
            icon: "fa-right-from-bracket",
            title: t("menu.withdrawal"),
            url: "part-replacement",
            guiUrl: "part-withdrawal",
            actionType: "PART_WITHDRAW",
        },
        cleaning: {
            icon: "fa-burn",
            title: t("menu.cleaning"),
            url: "cleaning",
            actionType: "CLEANING",
        },
        review: {
            icon: "fa-eye",
            title: t("common.review"),
            url: "review",
            actionType: "REVIEW",
        },
        service: {
            icon: "fa-wrench",
            title: t("menu.service"),
            url: "service",
            child: [
                "serviceStart", "serviceEnd"
            ]
        },
        serviceStart: {
            icon: "fa-wrench",
            title: t("menu.service_start"),
            url: "service",
            actionSubtype: "start",
            actionType: "SERVICE_START",
        },
        serviceEnd: {
            icon: "fa-wrench",
            title: t("menu.service_end"),
            url: "service",
            actionSubtype: "end",
            actionType: "SERVICE_END",
        },
        dimensioning: {
            icon: "fa-ruler-combined",
            title: t("menu.dimensioning"),
            url: "dimensioning",
            child: [
                "dimensioningStart", "dimensioningEnd"
            ]
        },
        dimensioningStart: {
            icon: "fa-ruler-combined",
            title: t("menu.dimensioning_start"),
            url: "dimensioning",
            actionSubtype: "start",
            actionType: "DIMENSIONING_START",
        },
        dimensioningEnd: {
            icon: "fa-ruler-combined",
            title: t("menu.dimensioning_end"),
            url: "dimensioning",
            actionSubtype: "end",
            actionType: "DIMENSIONING_END",
        },
        list: {
            icon: "fa-bars-staggered",
            title: t("menu.parts_list"),
            url: "list",
        }
    };
};

// Legacy exports for backward compatibility
const models = {
    icons: {
        home: "fa-home",
        line: "fa-line", 
        format: "fa-format",
        trash: "fa-trash"
    },
    font: {
        title: "Zarządzanie czcionkami",
        icon: "fa-font"
    },
    format: {
        title: "Zarządzanie formatem",
        url: "/format"
    },
    production: {
        title: "Produkcja",
        url: "/production",
        icon: "fa-production"
    },
    storagePlace: {
        title: "Szafy formatowe",
        url: "/storagePlace"
    },
    review: {
        title: "Przegląd",
        actionType: "REVIEW"
    },
    parts: {
        title: "Lista części",
        actionType: "PARTS"
    }
    // ... other configurations
};

export { useModels };
export default models;
